import React, { useEffect, useState } from "react";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import { CheckCircle, XCircle, Loader2 } from "lucide-react";
import api from "@/lib/api";
import { useCart } from "@/context/CartContext";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const { clear } = useCart();
  const [status, setStatus] = useState("checking");
  const [orderNumber, setOrderNumber] = useState("");
  const sessionId = params.get("session_id");

  useEffect(() => {
    let attempts = 0;
    const poll = async () => {
      if (!sessionId) { setStatus("error"); return; }
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setStatus("success"); setOrderNumber(data.order_number); clear();
          localStorage.removeItem("skg_pending_order");
          return;
        }
        if (data.status === "expired" || data.payment_status === "failed") { setStatus("error"); return; }
      } catch { setStatus("error"); return; }
      if (attempts++ < 8) setTimeout(poll, 1800);
      else setStatus("pending");
    };
    poll();
  }, [sessionId]); // eslint-disable-line

  return (
    <div className="max-w-lg mx-auto px-4 py-24 text-center">
      {status === "checking" && <><Loader2 className="w-14 h-14 text-[#FF2E4C] mx-auto animate-spin mb-6" /><h1 className="font-display text-2xl font-black uppercase">Επιβεβαίωση πληρωμής...</h1></>}
      {status === "success" && (
        <>
          <CheckCircle className="w-16 h-16 text-green-500 mx-auto mb-6" />
          <h1 className="font-display text-3xl font-black uppercase tracking-tight mb-3">Ευχαριστούμε!</h1>
          <p className="text-zinc-400 mb-2">Η πληρωμή ολοκληρώθηκε με επιτυχία.</p>
          <p className="font-mono text-[#FF2E4C] mb-8">#{orderNumber}</p>
          <div className="flex gap-3 justify-center">
            <Link to={`/tracking/${orderNumber}`} className="btn-red px-8 py-3 text-xs font-bold tracking-widest uppercase rounded">ΠΑΡΑΚΟΛΟΥΘΗΣΗ</Link>
            <Link to="/shop" className="px-8 py-3 text-xs font-bold tracking-widest uppercase rounded border border-zinc-700">ΣΥΝΕΧΕΙΑ</Link>
          </div>
        </>
      )}
      {(status === "pending") && <><Loader2 className="w-14 h-14 text-[#FF2E4C] mx-auto animate-spin mb-6" /><h1 className="font-display text-2xl font-black uppercase mb-3">Η πληρωμή επεξεργάζεται</h1><p className="text-zinc-400">Θα λάβεις email επιβεβαίωσης σύντομα.</p></>}
      {status === "error" && (
        <>
          <XCircle className="w-16 h-16 text-red-500 mx-auto mb-6" />
          <h1 className="font-display text-2xl font-black uppercase mb-3">Κάτι πήγε στραβά</h1>
          <p className="text-zinc-400 mb-8">Η πληρωμή δεν ολοκληρώθηκε.</p>
          <Link to="/checkout" className="btn-red px-8 py-3 text-xs font-bold tracking-widest uppercase rounded">ΔΟΚΙΜΑΣΕ ΞΑΝΑ</Link>
        </>
      )}
    </div>
  );
}

export function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="max-w-lg mx-auto px-4 py-24 text-center">
      <XCircle className="w-16 h-16 text-zinc-500 mx-auto mb-6" />
      <h1 className="font-display text-2xl font-black uppercase mb-3">Η πληρωμή ακυρώθηκε</h1>
      <p className="text-zinc-400 mb-8">Δεν χρεώθηκες. Το καλάθι σου διατηρήθηκε.</p>
      <button onClick={() => navigate("/checkout")} className="btn-red px-8 py-3 text-xs font-bold tracking-widest uppercase rounded">ΕΠΙΣΤΡΟΦΗ ΣΤΟ CHECKOUT</button>
    </div>
  );
}
